const isNumeric = (number) => !Number.isNaN(+number);
const isSiret = (number) => {
  const clean = number.split(' ').join('').trim();
  return isNumeric(clean) && clean.length === 14;
};

const annualText = (price, annual) => `${price} €/${annual ? 'an' : 'mois'}`;

const formatPrice = (price, annual, prorata = 12.0) => {
  const formatted = parseFloat(price)
    / parseFloat(annual ? 1.0 : prorata);
  const fixed = formatted.toFixed(2);
  return (fixed || 0).toString().replace('.', ',');
};

const format = (price, annual, prorata = 12.0) => {
  const formatted = formatPrice(parseFloat(price), annual, prorata);
  return annualText(formatted, annual);
};

const spacingFormatPrice = (price) => (price ? price.toString()
  .replace('.00', '')
  .replace(/\B(?=(\d{3})+(?!\d))/g, ' ') : 0);

export {
  isNumeric,
  isSiret,
  annualText,
  formatPrice,
  format,
  spacingFormatPrice,
};
